import directory from './directory';
import document from './document';
import documentVersion from './documentVersion';
import permissions from './permissions';
import tree from './tree';

export const load = (params) => {
	directory(params);
	document(params);
	documentVersion(params);
	permissions(params);
	tree(params);
};


// WEBPACK FOOTER //
// ./src/js/endpoints/supportWorker/documents/root/controllers/index.js